import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@progress/kendo-react-buttons';
import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout';

import { logoutWI } from '../../Store/Actions/Pages/AccessPage';

import { RedirectUrl, RedirectWithComponent } from '../../Constants/Utils';
import { CookieAuthenModel } from '../../Models/CommonModel/CookieAuthenModel';
import { storageModel } from '../../Models/CommonModel/StorageModel';
import { MessageBoxKey, MessageBoxModel } from '../../Models/CommonModel/MessageBoxModel';
import MessageBox, { ConfirmMessageResult, Pattern, Title } from '../Common/MessageBox';

import Screen from "../../Resources/Screen.json";
import UrlRedirect from "../../Resources/UrlRedirect.json";

function Header(props) {
    const cookieAuthenModel = new CookieAuthenModel();

    const [loginModel, setLoginModel] = useState(cookieAuthenModel.GetWILoginModel());
    const [messageDialog, setMessageDialog] = useState(null);
    const [showMessageBox, setShowMessageBox] = useState(false);

    const freeeLoginModel = cookieAuthenModel.GetFreeeLoginModel();

    const dispatch = useDispatch();

    useEffect(() => {
        if (!cookieAuthenModel.IsWIAuthorization()) {
            // Return login page if no have cookie of WorksI
            return RedirectWithComponent("/");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Event onClick button on MessageBox
    const onLogOut = (isLogoutAll) => {
        if (loginModel) {
            let params = {
                AccessKey: loginModel.AccessKey,
                RequestKey: loginModel.RequestKey
            };

            const callBack = (res) => {
                setLoginModel(null);
                storageModel.Reset();
                if (isLogoutAll) {
                    //Redirect url Freee if click button [OK] on MessageBox
                    window.location.href = UrlRedirect.UrlFreee;
                }
                else {
                    //Redirect login page if click button [Cancel] on MessageBox
                    return RedirectWithComponent('/');
                }
            };

            const logoutAction = logoutWI(params, isLogoutAll, callBack);
            dispatch(logoutAction);
        }
        else {
            // Redirect login page if no have cookie of WorksI
            RedirectUrl("/");
        }
    }

    // Message comfirm logout
    const showDialogLogout = () => {
        let dialog = new MessageBoxModel({
            Sid: MessageBoxKey.Logout,
            Title: Title.DefaultTitle,
            Pattern: Pattern.OkCancel,
            Message: Screen.MessageBox.LogoutComfirm
        });
        setMessageDialog(dialog);
        setShowMessageBox(true);
    }

    const onSubmitMessageBox = (sid, value) => {
        switch (sid) {
            case MessageBoxKey.Logout:
                if (value === ConfirmMessageResult.Yes) {
                    onLogOut(true);
                }
                else if (value === ConfirmMessageResult.Cancel) {
                    onLogOut(false);
                }
                break;
            default:
                break;
        }

        // reset dialog & close
        setMessageDialog(null);
        setShowMessageBox(false);
    }

    return <React.Fragment>
        {messageDialog && showMessageBox && <MessageBox
            sid={messageDialog.Sid}
            title={messageDialog.Title}
            pattern={messageDialog.Pattern}
            message={messageDialog.Message}
            submit={onSubmitMessageBox}></MessageBox>}
        <AppBar className="pnxAppBar">
            <AppBarSpacer />
            <AppBarSection>
                {loginModel && <label className="content-size" style={{ margin: 5 }}>
                    <b> {Screen.HeaderUserContent.LableWorkIUserTitle} </b> {loginModel.UserName}
                </label>}
                {freeeLoginModel && <label className="content-size" style={{ margin: 5 }}>
                    <b>{Screen.HeaderUserContent.LableFreeeUserTitle} </b>{freeeLoginModel}
                </label>}
            </AppBarSection>
            <AppBarSpacer style={{ width: 4 }} />
            <AppBarSection className="actions">
                <Button className="pnxBtnPrimary content-size" icon="logout" onClick={showDialogLogout}>
                    ログアウト
                </Button >
            </AppBarSection>
        </AppBar>
    </React.Fragment >
}

export default Header;